export const HOME_GALLERY_ITEM_BUFFER = 1;
export const HOME_GALLERY_ITEMS_IN_CENTER = 1;
export const HOME_GALLERY_STREAM_LOAD_TRIGGER_COUNT = 3;
